export const permissions = {
    alert: {
        view: ['ROLE_ADMIN', 'ROLE_ADMIN_ALERT', 'ROLE_USER'],
        actions: ['ROLE_ADMIN', 'ROLE_ADMIN_ALERT', 'ROLE_USER'],
        create: ['ROLE_ADMIN', 'ROLE_ADMIN_ALERT', 'ROLE_USER'],
        update: ['ROLE_ADMIN', 'ROLE_ADMIN_ALERT', 'ROLE_USER'],
        delete: ['ROLE_ADMIN', 'ROLE_ADMIN_ALERT', 'ROLE_USER']
    },
    customer: {
        view: ['ROLE_ADMIN', 'ROLE_ADMIN_CUSTOMER'],
        actions: ['ROLE_ADMIN', 'ROLE_ADMIN_CUSTOMER'],
        create: ['ROLE_ADMIN', 'ROLE_ADMIN_CUSTOMER'],
        update: ['ROLE_ADMIN', 'ROLE_ADMIN_CUSTOMER'],
        delete: ['ROLE_ADMIN', 'ROLE_ADMIN_CUSTOMER']
    },
    package: {
        view: [
            'ROLE_VIEW_RECEIPT',
            'ROLE_ADMIN_RECEIPT',
            'ROLE_ADMIN',
            'ROLE_ADMIN_PACK',
            'ROLE_ADMIN_STATUS',
            'ROLE_USER',
            'ROLE_VIEW_POBOX'
        ],
        actions: [
            'ROLE_ADMIN_RECEIPT',
            'ROLE_ADMIN',
            'ROLE_ADMIN_PACK',
            'ROLE_VIEW_POBOX'
        ],
        create: ['ROLE_ADMIN_RECEIPT', 'ROLE_ADMIN', 'ROLE_ADMIN_PACK'],
        update: ['ROLE_ADMIN_RECEIPT', 'ROLE_ADMIN', 'ROLE_ADMIN_PACK'],
        delete: ['ROLE_ADMIN_RECEIPT', 'ROLE_ADMIN', 'ROLE_ADMIN_PACK']
    },
    pobox: {
        view: ['ROLE_ADMIN_POBOX', 'ROLE_ADMIN', 'ROLE_ADMIN_ALERT'],
        actions: ['ROLE_ADMIN_POBOX', 'ROLE_ADMIN'],
        create: ['ROLE_ADMIN_POBOX', 'ROLE_ADMIN'],
        update: ['ROLE_ADMIN_POBOX', 'ROLE_ADMIN'],
        delete: ['ROLE_ADMIN_POBOX', 'ROLE_ADMIN']
    },
    prepack: {
        view: [
            'ROLE_ADMIN_PREPACK',
            'ROLE_ADMIN_RECEIPT',
            'ROLE_ADMIN',
            'ROLE_VIEW_RECEIPT'
        ],
        actions: ['ROLE_ADMIN_PREPACK', 'ROLE_ADMIN_RECEIPT', 'ROLE_ADMIN'],
        create: ['ROLE_ADMIN_PREPACK', 'ROLE_ADMIN_RECEIPT', 'ROLE_ADMIN'],
        update: ['ROLE_ADMIN_PREPACK', 'ROLE_ADMIN_RECEIPT', 'ROLE_ADMIN'],
        delete: ['ROLE_ADMIN_PREPACK', 'ROLE_ADMIN_RECEIPT', 'ROLE_ADMIN']
    },
    warehouses: {
        view: [
            'ROLE_VIEW_RECEIPT',
            'ROLE_ADMIN_RECEIPT',
            'ROLE_ADMIN',
            'ROLE_VIEW_POBOX',
            'ROLE_ADMIN_STATUS'
        ],
        actions: ['ROLE_ADMIN', 'ROLE_ADMIN_RECEIPT', 'ROLE_VIEW_POBOX'],
        create: ['ROLE_ADMIN', 'ROLE_ADMIN_RECEIPT', 'ROLE_CREATE_WR'],
        update: ['ROLE_ADMIN', 'ROLE_ADMIN_RECEIPT'],
        delete: ['ROLE_ADMIN', 'ROLE_ADMIN_RECEIPT']
    },
    shipments: {
        view: [
            'ROLE_ADMIN',
            'ROLE_ADMIN_GUIDE',
            'ROLE_VIEW_GUIDE',
            'ROLE_VIEW_POBOX',
            'ROLE_ADMIN_STATUS'
        ],
        actions: ['ROLE_ADMIN', 'ROLE_ADMIN_GUIDE', 'ROLE_VIEW_POBOX'],
        create: ['ROLE_ADMIN', 'ROLE_ADMIN_GUIDE'],
        update: ['ROLE_ADMIN', 'ROLE_ADMIN_GUIDE', 'ROLE_ADMIN_UPDATE_GUIDE'],
        delete: ['ROLE_ADMIN', 'ROLE_ADMIN_GUIDE', 'ROLE_ADMIN_UPDATE_GUIDE']
    },
    repacking: {
        view: [
            'ROLE_VIEW_POBOX',
            'ROLE_ADMIN_RECEIPT',
            'ROLE_ADMIN',
            'ROLE_CREATE_REPACKREQUEST',
            'VIEW_RECEIPT',
            'ROLE_ADMIN_POBOX'
        ],
        actions: [
            'ROLE_ADMIN_RECEIPT',
            'ROLE_ADMIN',
            'ROLE_ADMIN_PACK',
            'ROLE_VIEW_POBOX'
        ],
        process: ['ROLE_ADMIN_RECEIPT', 'ROLE_ADMIN', 'ROLE_ADMIN_PACK'],
        create: [
            'ROLE_ADMIN_RECEIPT',
            'ROLE_ADMIN',
            'ROLE_ADMIN_PACK',
            'ROLE_VIEW_POBOX'
        ],
        update: ['ROLE_ADMIN_RECEIPT', 'ROLE_ADMIN', 'ROLE_ADMIN_PACK'],
        delete: ['ROLE_ADMIN_RECEIPT', 'ROLE_ADMIN', 'ROLE_ADMIN_PACK']
    },
    loadunits: {
        view: [
            'ROLE_VIEW_LOADUNIT',
            'ROLE_ADMIN_LOADUNIT',
            'ROLE_ADMIN',
            'ROLE_ADMIN_PACK',
            'ROLE_ADMIN_STATUS'
        ],
        actions: ['ROLE_ADMIN_LOADUNIT', 'ROLE_ADMIN', 'ROLE_ADMIN_PACK'],
        create: ['ROLE_ADMIN_LOADUNIT', 'ROLE_ADMIN', 'ROLE_ADMIN_PACK'],
        update: ['ROLE_ADMIN_LOADUNIT', 'ROLE_ADMIN', 'ROLE_ADMIN_PACK'],
        delete: ['ROLE_ADMIN_LOADUNIT', 'ROLE_ADMIN', 'ROLE_ADMIN_PACK']
    },
    consolidated: {
        view: [
            'ROLE_VIEW_CONSOLIDATED',
            'ROLE_ADMIN_CONSOLIDATED',
            'ROLE_ADMIN'
        ],
        actions: ['ROLE_ADMIN_CONSOLIDATED', 'ROLE_ADMIN', 'ROLE_ADMIN_PACK'],
        create: ['ROLE_ADMIN_CONSOLIDATED', 'ROLE_ADMIN', 'ROLE_ADMIN_PACK'],
        update: ['ROLE_ADMIN_CONSOLIDATED', 'ROLE_ADMIN', 'ROLE_ADMIN_PACK'],
        delete: ['ROLE_ADMIN_CONSOLIDATED', 'ROLE_ADMIN', 'ROLE_ADMIN_PACK']
    },
    invoices: {
        view: [
            'ROLE_VIEW_BILL',
            'ROLE_ADMIN_BILL',
            'ROLE_ADMIN',
            'ROLE_ADMIN_POBOX',
            'ROLE_VIEW_POBOX'
        ],
        actions: ['ROLE_ADMIN_BILL', 'ROLE_ADMIN'],
        create: ['ROLE_ADMIN_BILL', 'ROLE_ADMIN'],
        update: ['ROLE_ADMIN_BILL', 'ROLE_ADMIN'],
        delete: ['ROLE_ADMIN_BILL', 'ROLE_ADMIN']
    },
    payments: {
        view: [
            'ROLE_VIEW_BILL',
            'ROLE_ADMIN_BILL',
            'ROLE_ADMIN',
            'ROLE_VIEW_POBOX'
        ],
        actions: ['ROLE_ADMIN', 'ROLE_ADMIN_BILLPAY', 'ROLE_ADD_PAYMENT'],
        create: ['ROLE_ADMIN', 'ROLE_ADMIN_BILLPAY', 'ROLE_ADD_PAYMENT'],
        update: ['ROLE_ADMIN', 'ROLE_ADMIN_BILLPAY', 'ROLE_ADD_PAYMENT'],
        delete: ['ROLE_ADMIN', 'ROLE_ADMIN_BILLPAY', 'ROLE_ADD_PAYMENT']
    },
    pickups: {
        view: [
            'ROLE_VIEW_PICKUP',
            'ROLE_ADMIN_PICKUP',
            'ROLE_ADMIN',
            'ROLE_VIEW_POBOX'
        ],
        actions: [
            'ROLE_ADMIN',
            'ROLE_ADMIN_PICKUP',
            'ROLE_PICKUP_MANAGER',
            'ROLE_ADMIN_PICKUP_ALL',
            'ROLE_PICKUP_PROCESSOR'
        ],
        create: [
            'ROLE_PICKUP_PROCESSOR',
            'ROLE_ADMIN',
            'ROLE_PICKUP_MANAGER',
            'ROLE_ADMIN_PICKUP_ALL',
            'ROLE_VIEW_POBOX'
        ],
        update: [
            'ROLE_ADMIN_PICKUP',
            'ROLE_ADMIN',
            'ROLE_PICKUP_MANAGER',
            'ROLE_ADMIN_PICKUP_ALL',
            'ROLE_VIEW_POBOX'
        ],
        delete: [
            'ROLE_ADMIN',
            'ROLE_ADMIN_PICKUP',
            'ROLE_PICKUP_MANAGER',
            'ROLE_ADMIN_PICKUP_ALL'
        ]
    },
    deliveryList: {
        view: ['VIEW_DELIVERY_LIST', 'ROLE_ADMIN'],
        create: [
            'ROLE_ADMIN_DELIVERY',
            'ROLE_ADMIN',
            'ROLE_ADMIN_DELIVERYLIST_ALL',
            'ROLE_ADMIN_DELIVERYLIST'
        ],
        update: [
            'ROLE_ADMIN_DELIVERYLIST',
            'ROLE_ADMIN',
            'ROLE_ADMIN_DELIVERYLIST_ALL',
            'ROLE_ADMIN_DELIVERYLIST'
        ],
        delete: [
            'ROLE_ADMIN_DELIVERYLIST',
            'ROLE_ADMIN',
            'ROLE_ADMIN_DELIVERYLIST_ALL',
            'ROLE_ADMIN_DELIVERYLIST'
        ]
    },
    pickups_orders: {
        view: ['ROLE_ADMIN_PICKUP', 'ROLE_ADMIN'],
        actions: [
            'ROLE_ADMIN',
            'ROLE_ADMIN_PICKUP',
            'ROLE_PICKUP_MANAGER',
            'ROLE_ADMIN_PICKUP_ALL',
            'ROLE_PICKUP_PROCESSOR'
        ],
        create: [
            'ROLE_PICKUP_PROCESSOR',
            'ROLE_ADMIN',
            'ROLE_PICKUP_MANAGER',
            'ROLE_ADMIN_PICKUP_ALL'
        ],
        update: [
            'ROLE_ADMIN_PICKUP',
            'ROLE_ADMIN',
            'ROLE_PICKUP_MANAGER',
            'ROLE_ADMIN_PICKUP_ALL'
        ],
        delete: [
            'ROLE_ADMIN',
            'ROLE_ADMIN_PICKUP',
            'ROLE_PICKUP_MANAGER',
            'ROLE_ADMIN_PICKUP_ALL'
        ]
    },
    cities: {
        view: ['ROLE_ADMIN', 'ROLE_ADMIN_CITY'],
        create: ['ROLE_ADMIN', 'ROLE_ADMIN_CITY'],
        update: ['ROLE_ADMIN', 'ROLE_ADMIN_CITY'],
        delete: ['ROLE_ADMIN', 'ROLE_ADMIN_CITY']
    },
    states: {
        view: ['ROLE_ADMIN', 'ROLE_ADMIN_STATE'],
        create: ['ROLE_ADMIN_STATE', 'ROLE_ADMIN'],
        update: ['ROLE_ADMIN_STATE', 'ROLE_ADMIN'],
        delete: ['ROLE_ADMIN_STATE', 'ROLE_ADMIN']
    },
    countries: {
        view: ['ROLE_ADMIN', 'ROLE_ADMIN_COUNTRY'],
        create: ['ROLE_ADMIN', 'ROLE_ADMIN_MAINCOMPANY'],
        update: ['ROLE_ADMIN', 'ROLE_ADMIN_MAINCOMPANY'],
        delete: ['ROLE_ADMIN', 'ROLE_ADMIN_MAINCOMPANY']
    },
    regions: {
        view: ['ROLE_ADMIN', 'ROLE_ADMIN_STATE'],
        create: ['ROLE_ADMIN', 'ROLE_ADMIN_STATE'],
        update: ['ROLE_ADMIN', 'ROLE_ADMIN_STATE'],
        delete: ['ROLE_ADMIN', 'ROLE_ADMIN_STATE']
    },
    seaPorts: {
        view: ['ROLE_ADMIN'],
        create: ['ROLE_ADMIN'],
        update: ['ROLE_ADMIN'],
        delete: ['ROLE_ADMIN']
    },
    carriers: {
        view: ['ROLE_ADMIN', 'ROLE_ADMIN_CARRIER'],
        create: ['ROLE_ADMIN', 'ROLE_ADMIN_CARRIER'],
        update: ['ROLE_ADMIN', 'ROLE_ADMIN_CARRIER'],
        delete: ['ROLE_ADMIN', 'ROLE_ADMIN_CARRIER']
    },
    vehicles: {
        view: ['ROLE_VIEW_VEHICLE', 'ROLE_ADMIN_VEHICLE', 'ROLE_ADMIN'],
        create: ['ROLE_ADMIN_VEHICLE', 'ROLE_ADMIN'],
        update: ['ROLE_ADMIN_VEHICLE', 'ROLE_ADMIN'],
        delete: ['ROLE_ADMIN_VEHICLE', 'ROLE_ADMIN']
    },
    transporters: {
        view: ['ROLE_ADMIN', 'ROLE_ADMIN_TRANSPORTER'],
        create: ['ROLE_ADMIN', 'ROLE_ADMIN_TRANSPORTER'],
        update: ['ROLE_ADMIN', 'ROLE_ADMIN_TRANSPORTER'],
        delete: ['ROLE_ADMIN', 'ROLE_ADMIN_TRANSPORTER']
    },
    warehouseRate: {
        view: ['ROLE_ADMIN', 'ROLE_ADMIN_TARIFF'],
        create: ['ROLE_ADMIN', 'ROLE_ADMIN_TARIFF'],
        update: ['ROLE_ADMIN', 'ROLE_ADMIN_TARIFF'],
        delete: ['ROLE_ADMIN', 'ROLE_ADMIN_TARIFF']
    },
    shipmentRate: {
        view: ['ROLE_ADMIN', 'ROLE_ADMIN_TARIFF'],
        create: ['ROLE_ADMIN', 'ROLE_ADMIN_TARIFF'],
        update: ['ROLE_ADMIN', 'ROLE_ADMIN_TARIFF'],
        delete: ['ROLE_ADMIN', 'ROLE_ADMIN_TARIFF']
    },
    agencies: {
        view: ['ROLE_ADMIN', 'ROLE_ADMIN_AGENCY', 'ROLE_VIEW_AGENCY'],
        create: ['ROLE_ADMIN', 'ROLE_ADMIN_AGENCY'],
        update: ['ROLE_ADMIN', 'ROLE_ADMIN_AGENCY'],
        delete: ['ROLE_ADMIN', 'ROLE_ADMIN_AGENCY']
    },
    users: {
        view: ['ROLE_ADMIN', 'ROLE_ADMIN_USER', 'ROLE_VIEW_USER'],
        create: ['ROLE_ADMIN', 'ROLE_ADMIN_USER'],
        update: ['ROLE_ADMIN', 'ROLE_ADMIN_USER'],
        delete: ['ROLE_ADMIN', 'ROLE_ADMIN_USER']
    },
    locations: {
        view: ['ROLE_ADMIN', 'ROLE_ADMIN_LOCATION'],
        create: ['ROLE_ADMIN', 'ROLE_ADMIN_LOCATION'],
        update: ['ROLE_ADMIN', 'ROLE_ADMIN_LOCATION'],
        delete: ['ROLE_ADMIN', 'ROLE_ADMIN_LOCATION']
    },
    branches: {
        view: ['ROLE_VIEW_COMPANY', 'ROLE_ADMIN_COMPANY', 'ROLE_ADMIN'],
        create: ['ROLE_ADMIN', 'ROLE_ADMIN_COMPANY'],
        update: ['ROLE_ADMIN', 'ROLE_ADMIN_COMPANY'],
        delete: ['ROLE_ADMIN', 'ROLE_ADMIN_COMPANY']
    },
    localTransporters: {
        view: [
            'ROLE_VIEW_LOCALCOMPANY',
            'ROLE_ADMIN_LOCALCOMPANY',
            'ROLE_ADMIN'
        ],
        create: ['ROLE_ADMIN_LOCALCOMPANY', 'ROLE_ADMIN'],
        update: ['ROLE_ADMIN_LOCALCOMPANY', 'ROLE_ADMIN'],
        delete: ['ROLE_ADMIN_LOCALCOMPANY', 'ROLE_ADMIN']
    },
    zones: {
        view: ['ROLE_ADMIN', 'ROLE_ADMIN_LOCATION'],
        create: ['ROLE_ADMIN', 'ROLE_ADMIN_LOCATION'],
        update: ['ROLE_ADMIN', 'ROLE_ADMIN_LOCATION'],
        delete: ['ROLE_ADMIN', 'ROLE_ADMIN_LOCATION']
    },
    searches: {
        view: ['ROLE_ADMIN']
    },
    hide: {
        pobox: {
            links: ['ROLE_VIEW_POBOX'],
            agencyFilter: ['ROLE_ADMIN_RECEIPT', 'ROLE_ADMIN'],
            locationFilter: ['ROLE_ADMIN_RECEIPT', 'ROLE_ADMIN'],
            receivedByFilter: ['ROLE_ADMIN_RECEIPT', 'ROLE_ADMIN'],
            agentFilter: ['ROLE_ADMIN_RECEIPT', 'ROLE_ADMIN'],
            processedByFilter: ['ROLE_ADMIN_RECEIPT', 'ROLE_ADMIN'],
            poboxFilter: ['ROLE_ADMIN_ALERT', 'ROLE_ADMIN']
        }
    }
};
